module.exports = __webpack_public_path__ + "static/media/square_payment.7b8aab2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/square_payment.png
// module id = 1380
// module chunks = 0